/* eslint-disable import/prefer-default-export */
import EntryActionTypes from '../../constants/EntryActionTypes';

export const updateAlerts = () => ({
  type: EntryActionTypes.ALERT_DISPLAYED,
  payload: {},
});

export const fetchAlertData = (deviceId, data) => ({
  type: EntryActionTypes.ALERT_DATA,
  payload: {
    deviceId,
    data,
  },
});
